<content-header [activeTab]="activeTab"
                [entriesLength]="!!entriesLength"
                [loading]="loading"

                [filters]="filters"
                [togglers]="togglers"
                [dropdowns]="dropdowns"
                (togglersChanged)="togglersChanged.emit($event)"
                (filtersChanged)="filtersChanged.emit($event)"
                (dropdownsChanged)="dropdownsChanged.emit($event)"

                [button]="button"
                (buttonCallback)="buttonCallback.emit($event)"

                [printAvailable]="!!print.observed"
                [excelAvailable]="!!excel.observed"
                [disablePrint]="disablePrint"
                [disableExcel]="disableExcel"

                (print)="print.emit($event)"
                (excel)="excel.emit($event)"

                (reload)="callback.emit($event)">
</content-header>
<div class="bb-grey"></div>
<div class="am-flex-column size-parent">
  <div class="am-flex-align gap-s c620-flex-column">
    @if (searchEntryType) {
      <pagination-search class="am-flex-370 c620-width-full c620-flex-1-i c620-flex-align-start" [tooltipItems]="searchTooltipItems" [entryType]="searchEntryType" [loading]="loading" (callback)="callback.emit($event)"></pagination-search>
      <span class="height-xl br-grey c620-hide xs-hide"></span>
    }
    <pills-button class="c620-width-full xs-hide" [skipInitLoad]="skipInitLoad" [loading]="loading" (callback)="callback.emit($event)"></pills-button>
  </div>
</div>
